import React, { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import Plans from "@/components/Plans";
import StatementBand from "@/components/StatementBand";
import HowItWorks from "@/components/HowItWorks";
import Projects from "@/components/Projects";
import Cases from "@/components/Cases";
import Audience from "@/components/Audience";
import QuoteForm from "@/components/QuoteForm";
import RealizaTech from "@/components/RealizaTech";
import InstagramFeed from "@/components/InstagramFeed";
import Faq from "@/components/Faq";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-navy-950 text-slate-300">
          Algo deu errado. Atualize a página.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (href.length > 1) {
        const el = document.querySelector(href);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -76 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-navy-950 font-body text-slate-100">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <About />
          <Services />
          <WhyChoose />
          <Plans />
          <StatementBand />
          <HowItWorks />
          <Projects />
          <Cases />
          <Audience />
          <QuoteForm />
          <RealizaTech />
          <InstagramFeed />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="bottom-left" theme="dark" richColors />
      </div>
    </ErrorBoundary>
  );
}

export default App;
